
  
  // ** Search Partner
  export const searchPartner = (email, callback) => {
    return dispatch => {
      dispatch({
        type: 'PARTNER_SEARCH',
        email,
        callback
      })
    }
  }
  
  // ** Table data load success
  export const searchPartnerSuccess = partner => {
      return dispatch => {
        dispatch({
          type: 'PARTNER_SEARCH_SUCCESS',
          partner
        })
      }
  }
  
  
  // ** Table data load fail
  export const searchPartnerFail = errors => {
      return dispatch => {
        dispatch({
          type: 'PARTNER_SEARCH_FAIL',
          errors
        })
      }
  }

  // ** Search Impact
  export const searchImpact = (q) => {
    return dispatch => {
      dispatch({
        type: 'IMPACT_SEARCH',
        q
      })
    }
  }
      
    // ** Impact data load success
  export const searchImpactSuccess = data => {
      return dispatch => {
        dispatch({
          type: 'IMPACT_SEARCH_SUCCESS',
          data
        })
      }
  }
    
    
  // ** Impact data load fail
  export const searchImpactFail = errors => {
      return dispatch => {
        dispatch({
          type: 'IMPACT_SEARCH_FAIL',
          errors
        })
      }
  }


  // ** Search Material
  export const searchMaterial = (q) => {
    return dispatch => {
      dispatch({
        type: 'MATERIAL_SEARCH',
        q
      })
    }
  }
      
  // ** Impact data load success
  export const searchMaterialSuccess = data => {
      return dispatch => {
        dispatch({
          type: 'MATERIAL_SEARCH_SUCCESS',
          data
        })
      }
  }
      
      
  // ** Impact data load fail
  export const searchMaterialFail = errors => {
      return dispatch => {
        dispatch({
          type: 'MATERIAL_SEARCH_FAIL',
          errors
        })
      }
  }


  // ** Search Material
  export const searchMaterialTypes = (q) => {
    return dispatch => {
      dispatch({
        type: 'MATERIAL_TYPES_SEARCH',
        q
      })
    }
  }
      
  // ** Impact data load success
  export const searchMaterialTypesSuccess = data => {
      return dispatch => {
        dispatch({
          type: 'MATERIAL_TYPES_SEARCH_SUCCESS',
          data
        })
      }
  }
      
      
  // ** Impact data load fail
  export const searchMaterialTypesFail = errors => {
      return dispatch => {
        dispatch({
          type: 'MATERIAL_TYPES_SEARCH_FAIL',
          errors
        })
      }
  }

    // ** Search Material
    export const searchSharedMaterials = (q) => {
      return dispatch => {
        dispatch({
          type: 'SHARED_MATERIALS_SEARCH',
          q
        })
      }
    }
        
    // ** Search Material load success
    export const searchSharedMaterialsSuccess = data => {
        return dispatch => {
          dispatch({
            type: 'SHARED_MATERIALS_SEARCH_SUCCESS',
            data
          })
        }
    }
        
        
    // ** Search Material load fail
    export const searchSharedMaterialsFail = errors => {
        return dispatch => {
          dispatch({
            type: 'SHARED_MATERIALS_SEARCH_FAIL',
            errors
          })
        }
    }


   // ** Init Search Action for autocomplete data for dropdown
   export const searchTable = (tableType, q, additionalParam = null) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_AUTOCOMPLETE',
        tableType,
        q,
        additionalParam
      })
    }
  }
      
  // ** Search Action for autocomplete data for dropdown success
  export const searchTableSuccess = (tableType, data) => {
      return dispatch => {
        dispatch({
          type: 'TABLE_AUTOCOMPLETE_SUCCESS',
          tableType,
          data
        })
      }
  }
      
      
  // ** Search Action for autocomplete data for dropdown fail
  export const searchTableFail = (tableType, errors) => {
      return dispatch => {
        dispatch({
          type: 'TABLE_AUTOCOMPLETE_FAIL',
          tableType,
          errors
        })
      }
  }